import { DELETE } from './methods/DELETE';
import { GET } from './methods/GET';
import { POST } from './methods/POST';
import { PUT } from './methods/PUT';

export default { DELETE, GET, POST, PUT };
